import { Directive, inject, OnInit, ViewChild } from '@angular/core';
import { Store } from '@sama/app-state';
import { DirectiveSuperclass } from '@sama/ng-core';
import { buffer, merge, Observable } from 'rxjs';
import { debounceTime, filter, map } from 'rxjs/operators';
import { KeyboardShortcutService } from '../../../../cross-team-shared/misc-services/keyboard-shortcut.service';
import { ObjectlessViewSettingsSliderComponent } from '../../../../cross-team-shared/toolbars/view-settings/objectless-view-settings-slider.component';
import { AbstractSensorContentStore2D } from '../../state/abstract-sensor-content-store-2d';

@Directive()
export abstract class AbstractViewSettingsImageSliderComponent
  extends DirectiveSuperclass
  implements OnInit
{
  @ViewChild(ObjectlessViewSettingsSliderComponent, { static: true })
  private slider!: ObjectlessViewSettingsSliderComponent;

  disabled$!: Observable<boolean>;
  layerStore!: Store<number>;

  private store = inject(AbstractSensorContentStore2D);
  private keyboardShortcutService = inject(KeyboardShortcutService);

  abstract settingName: 'brightness' | 'contrast';

  ngOnInit() {
    this.layerStore = this.store('layerSettings')(this.settingName);
    this.disabled$ = this.store('viewMode').$.pipe(
      map((viewMode) => viewMode === 'layers'),
    );

    const shortcuts$ = this.getShortcuts$();
    this.subscribeTo(
      shortcuts$.pipe(
        buffer(shortcuts$.pipe(debounceTime(0))),
        filter(
          (shortcuts) =>
            shortcuts.includes('increase') && shortcuts.includes('decrease'),
        ),
      ),
      () => this.slider.reset('keyboard_shortcut'),
    );
  }

  getShortcuts$() {
    const decrease$ = this.keyboardShortcutService
      .getMatchingEvent$('decreaseBrightness', 'decreaseContrast')
      .pipe(map(() => 'decrease'));

    const increase$ = this.keyboardShortcutService
      .getMatchingEvent$('increaseBrightness', 'increaseContrast')
      .pipe(map(() => 'increase'));

    return merge(decrease$, increase$);
  }
}
